var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, computed, observable, makeObservable } from 'mobx';
import { history } from '../AppRouter';
import CarsAPI from '../services/CarsAPI';
import VehicleInfoAPI from '../services/VehicleInfoAPI';
import { transformGeneralGroupedInfo } from '../framework/DataTransformers';
import { DEFAULT_GROUPED_INFO } from '../framework/constants/cars';
import NotificationStore from './NotificationStore';
import { i18nextInstance } from '../../i18n';
class VehicleAddStore {
    constructor() {
        Object.defineProperty(this, "vehicleDataLoading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "groupedInfo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: DEFAULT_GROUPED_INFO
        });
        Object.defineProperty(this, "groupedInfoLoaded", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "modelVariants", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "modelVariantsLoaded", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "modelVariantsLoading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isSaving", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "getGeneralGroupedInfo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (query) => {
                return VehicleInfoAPI.getGeneralGroupedInfo(query)
                    .then((response) => {
                    const queryKeys = Object.keys(query);
                    if (!this.groupedInfoLoaded) {
                        this.groupedInfoLoaded = true;
                    }
                    const groupedInfo = transformGeneralGroupedInfo(response);
                    Object.keys(groupedInfo).forEach((key) => {
                        if (!queryKeys.includes(key)) {
                            this.groupedInfo[key] = groupedInfo[key];
                        }
                    });
                    return this.groupedInfo;
                })
                    .catch(() => {
                    this.groupedInfoLoaded = false;
                });
            }
        });
        Object.defineProperty(this, "getModelVariantsInfo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (query) => {
                this.modelVariantsLoading = true;
                return VehicleInfoAPI.getModelVariantsInfo(query)
                    .then((response) => {
                    this.modelVariants = response;
                    this.modelVariantsLoading = false;
                    this.modelVariantsLoaded = true;
                    return this.modelVariants;
                })
                    .catch(() => {
                    this.modelVariantsLoaded = false;
                    this.modelVariantsLoading = false;
                });
            }
        });
        Object.defineProperty(this, "createCar", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (car, type) => {
                this.isSaving = true;
                return CarsAPI.createCar(car).then((result) => {
                    const carId = result.data._id;
                    if (type === 'save') {
                        history.push(`/my-vehicles/overview`);
                    }
                    else {
                        history.push(`/my-vehicles/${carId}/image-upload`);
                    }
                }).catch((error) => {
                    NotificationStore.addNotification({
                        message: i18nextInstance.t('VehicleEditPage:messages.carCreationError'),
                        level: 'error'
                    });
                    throw error;
                }).finally(() => {
                    this.isSaving = false;
                });
            }
        });
        // @action prepareNewCarData = (datGroupID: string) => {
        //   // If there are no model variants, then just
        //   // allow user to proceed to next(edit screen)
        //   // where he can fill all the fields manually
        //   if (this.isModelUnique) {
        //     // TODO: place code here
        //     return;
        //   }
        //
        //   this.vehicleDataLoading = true;
        //
        //   return CarsAPI.getCarDataByDatGroupID(datGroupID)
        //     .then((response: any) => {
        //       // this.tempVehicleData = response;
        //       this.vehicleDataLoading = false;
        //     })
        //     .catch((error) => {
        //       console.log('error', error);
        //       this.vehicleDataLoading = false;
        //     });
        // };
        Object.defineProperty(this, "clearModelVariants", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.modelVariants = [];
                this.modelVariantsLoaded = false;
                this.clearTempVehicleData();
            }
        });
        Object.defineProperty(this, "clearTempVehicleData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                // this.tempVehicleData = {};
            }
        });
        makeObservable(this);
    }
    get isModelUnique() {
        return (this.groupedInfoLoaded && !this.groupedInfo.fuel.length) ||
            (this.modelVariantsLoaded && !this.modelVariants.length);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], VehicleAddStore.prototype, "vehicleDataLoading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], VehicleAddStore.prototype, "groupedInfo", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], VehicleAddStore.prototype, "groupedInfoLoaded", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], VehicleAddStore.prototype, "modelVariants", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], VehicleAddStore.prototype, "modelVariantsLoaded", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], VehicleAddStore.prototype, "modelVariantsLoading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], VehicleAddStore.prototype, "isSaving", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], VehicleAddStore.prototype, "isModelUnique", null);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleAddStore.prototype, "getGeneralGroupedInfo", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleAddStore.prototype, "getModelVariantsInfo", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleAddStore.prototype, "createCar", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleAddStore.prototype, "clearModelVariants", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], VehicleAddStore.prototype, "clearTempVehicleData", void 0);
export default new VehicleAddStore();
